import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.send(
      'service_fk4lsjs',
      'template_q6j6s2c',
      formData,
      'Vus4auGsEipa6IxcX'
    ).then(
      () => {
        alert('✅ Message sent successfully!');
        setFormData({ name: '', email: '', message: '' });
      },
      (error) => {
        console.error('EmailJS error:', error);
        alert('❌ Failed to send message. Please try again.');
      }
    );
  };

  return (
    <main className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
      <section className="max-w-4xl mx-auto py-12">
        <h1 className="text-4xl font-extrabold text-indigo-800 text-center mb-6">Contact Us</h1>
        <p className="text-lg text-gray-700 text-center mb-10">
          Whether you have a question, want to partner with us, or simply want to say hello—feel free to reach out. We'd love to hear from you!
        </p>

        <form onSubmit={handleSubmit} className="bg-white p-8 rounded-xl shadow space-y-6">
          <div>
            <label className="block text-gray-700 font-semibold mb-2">Full Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-4 py-2"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-2">Email Address</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-4 py-2"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-2">Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="5"
              className="w-full border border-gray-300 rounded px-4 py-2"
              required
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full bg-indigo-700 hover:bg-indigo-800 text-white font-bold py-3 rounded-xl transition"
          >
            Send Message
          </button>
        </form>

        <div className="mt-12 text-center text-gray-700">
          <p><strong>Email:</strong> support@empowerher.africa</p>
          <p><strong>WhatsApp:</strong> +254 712 345678</p>
          <p><strong>Location:</strong> Nairobi, Kenya</p>
        </div>
      </section>
    </main>
  );
};

export default Contact;
